// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"au","content":"av","header":"aw","message":"ax","iframeWrapper":"ay"};